"use client";
import { jsxs as h, Fragment as g, jsx as e } from "react/jsx-runtime";
import { forwardRef as p, createElement as w, cloneElement as b } from "react";
import i from "classnames";
import N from "../heading/Heading.js";
import y from "../loading-skeleton/LoadingSkeleton.js";
import v from "../button/Button.js";
import "../loader/Loader.js";
import '../../assets/Card.css';const C = "_card_1tdf4_9", j = "_white_1tdf4_27", k = "_neutral_1tdf4_30", x = "_soft_1tdf4_34", F = "_warm_1tdf4_37", A = "_vibrant_1tdf4_41", E = "_dark_1tdf4_44", I = "_badge_1tdf4_58", R = "_content_1tdf4_72", S = "_figure_1tdf4_82", B = "_img_1tdf4_114", H = "_cta_1tdf4_137", o = {
  card: C,
  white: j,
  neutral: k,
  soft: x,
  warm: F,
  vibrant: A,
  dark: E,
  "hide-border": "_hide-border_1tdf4_48",
  "hide-shadow": "_hide-shadow_1tdf4_51",
  badge: I,
  content: R,
  "only-img": "_only-img_1tdf4_79",
  figure: S,
  "img-loader": "_img-loader_1tdf4_114",
  img: B,
  cta: H
}, L = ({ children: a, as: t = "h2", variant: r = "h4", serif: s = !0, ...n }) => /* @__PURE__ */ e(N, { as: t, variant: r, serif: s, ...n, children: a }), O = ({ href: a, onClick: t, label: r, loading: s, ...n }) => {
  const d = {
    className: o.cta,
    representation: "button",
    variant: "secondary",
    isFullwidth: !0,
    loading: s,
    onClick: t
  };
  return a ? b(
    a,
    {
      ...n,
      ...d,
      isFullwidth: !0,
      variant: "secondary",
      representation: "button",
      className: o.cta,
      onClick: t
    },
    r
  ) : /* @__PURE__ */ e(v, { ...n, ...d, children: r });
}, _ = p(
  ({ border: a = !0, image: t, children: r, className: s, as: n = "div", color: d = "white", shadow: l, ...f }, m) => {
    const c = !!t && n !== "figure", u = c && !!r;
    return w(
      n,
      {
        className: i(
          o.card,
          o[d],
          {
            [o["hide-border"]]: !a,
            [o["hide-shadow"]]: !l
          },
          s
        ),
        ...f,
        ref: m,
        ...c && { "data-img-pos": (t == null ? void 0 : t.position) || "top" }
      },
      /* @__PURE__ */ h(g, { children: [
        c && /* @__PURE__ */ e("figure", { className: o.figure, children: t.src ? /* @__PURE__ */ e(
          "img",
          {
            className: i(o.img, { [o["only-img"]]: !!t && !r }, t.className),
            src: t.src,
            alt: t.alt
          }
        ) : typeof t.loading == "boolean" ? /* @__PURE__ */ e(
          y.Rectangle,
          {
            width: "100%",
            height: "100%",
            className: i(o["img-loader"], { [o["only-img"]]: !!t && !r })
          }
        ) : t.loading }),
        u ? /* @__PURE__ */ e("div", { "data-id": "card-content", className: o.content, children: r }) : r
      ] })
    );
  }
);
_.displayName = "Card";
const G = Object.assign(_, { Title: L, Action: O });
export {
  G as default
};
